
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, extend } from 'vee-validate';
import i18n from '@/i18n';

extend('noSpecialCharacters', {
  validate: (value) => {
    const forbiddenChars = ['#', '"', "'", '*', ','];
    return !forbiddenChars.some((char) => value.includes(char));
  },
  message: i18n.t('orders.reference.validation-error') as string,
});

@Component({
  components: { ValidationProvider },
})
export default class OrderReferenceField extends Vue {
  get orderReference(): string {
    return this.$store.state.order.cart.PurchOrder;
  }

  setOrderReference(reference: string) {
    this.$store.commit('order/setOrderReference', reference);
  }

  get active(): boolean {
    return !!this.orderReference;
  }
}
